export default __webpack_public_path__ + "static/media/cake1.6da5d53e.jpg";